<mat-form-field *ngIf="!formReadonlyMode"
                class="mxs-input mxs-date-picker mx-date-picker"
                [formGroup]="form"
                [ngClass]="{'hidden': hidden}"
                [matTooltip]="getValidationHint() | translate"
                [matTooltipClass]="'mxs-error-ttip'">
    <mat-label>{{getLabel() | translate}}</mat-label>
    <input matInput
           readonly
           [matDatepicker]="picker"
           [name]="name"
           [errorStateMatcher]=errorService
           [formControlName]="name"
           [required]="required"
           [max]=maxDate
           [min]=minDate
           (dateChange)="onDateChanged($event)"
           (click)="picker.open()"
    />
    <button *ngIf="isDisplayed()" matSuffix mat-icon-button type="button" aria-label="Clear"
            (click)="resetValue($event)">
        <mat-icon>clear</mat-icon>
    </button>
    <mat-datepicker-toggle *ngIf="!picker.disabled" matSuffix [for]="picker">
    </mat-datepicker-toggle>
    <mat-datepicker #picker (opened)="onOpen(datepickerFooter)" [startView]="getStartView()"
                    (monthSelected)="chosenMonthHandler($event, picker)"></mat-datepicker>
    <mat-hint>{{hint}}</mat-hint>
    <mat-error *ngFor="let error of getValidationMessages(true)">
        {{getError(error) | translate}}
    </mat-error>
    <div style="display: none">
        <div class="datepicker-footer" #datepickerFooter style="display: flex;justify-content: space-evenly; margin-bottom: 10px">
            <button mat-raised-button color="primary" style="border-radius: 28px" (click)="today(picker, $event)">
                Today
            </button>
        </div>
    </div>
</mat-form-field>

<mat-list-item class="mxs-readonly" *ngIf="formReadonlyMode"
               [ngClass]="{'hidden': hidden}">
    <div class="mxs-readonly_label">{{getLabel() | translate}}</div>
    <div class="mxs-readonly_input">
        {{ getDisplayValue(form.controls[name].value | zoneDate:dateFormat) }}
    </div>
</mat-list-item>

